












import Component from 'vue-class-component';
import Vue from 'vue';
import Banner from '@/shared/components/Banner.vue';
import {BOT_STUDIO_ENABLED} from '@/store/app/featureTypes';
import {Getter} from 'vuex-class';
import UpgradeModal from '@/features/bots/components/UpgradeModal.vue';

@Component({
	components: { Banner, UpgradeModal }
})
export default class UpgradeBanner extends Vue {
	@Getter public isWorkspaceFeatureEnabled!: (key: string, defaultValue?: boolean) => boolean;
	public upgradeModalOpen: boolean = false;

	public get botStudioEnabled() {
		return this.isWorkspaceFeatureEnabled(BOT_STUDIO_ENABLED, true);
	}

	public closeUpgradeModal() {
		this.upgradeModalOpen = false;
	}

	public openUpgradeModal() {
		this.upgradeModalOpen = true;
	}
}
